/* eslint-disable no-console */
/* eslint-disable max-len */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useContext, useState } from 'react';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/';
import { LanguageContext } from '../../../../libs/Context';
import { MediaContext } from '../..';
import usePermanentDelete from '../../customHooks/usePermanentDelete';

const DeletePopUp = (props) =>
{
	const { getTrashDataInfo, folderData, handlePopup } = props;
	const [ loading, setLoading ] = useState<boolean>(false);
	const { language } = useContext(LanguageContext);
	const { mediaState } = useContext(MediaContext);

	const folderIds = mediaState?.selectedData?.length > 0 && mediaState?.selectedData?.map((item:any) => item?.folderId);

	const deletePermanently = usePermanentDelete();

	const handleClose = () =>
	{
		handlePopup({ delete: false });
	};

	const handleDelete = () =>
	{
		setLoading(true);
		const idArr = folderIds?.length > 0 ? folderIds : [ folderData?.folderId ];

		deletePermanently({ idArray: idArr, setLoading, getTrashDataInfo });
		handleClose();
	};

	return (
		<Dialog
			open
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>
				{language?.delete}
			</DialogTitle>
			<DialogContent>
				{loading && <Loading />}
				<span>{language?.areyousureDelete}</span>
			</DialogContent>
			<DialogActions>
				<Button
					color='primary'
					disableElevation
					disableFocusRipple
					disableRipple
					disableTouchRipple
					onClick={handleClose}
				>
					{language?.cancel}
				</Button>
				<Button
					variant='contained'
					color='primary'
					className='whiteTxt'
					disableElevation
					disableFocusRipple
					disableRipple
					disableTouchRipple
					onClick={handleDelete}
				>
					{language?.delete}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DeletePopUp;